import React, { useState, useEffect } from 'react';
import RadioOption from "./RadioOption";
import Question from "./Question";
import FormGroupHeader from "./FormGroupHeader";
import Helper from "../display/Helper";
import HelperTrigger from "../display/HelperTrigger";
import { FormGroup } from "../layout/Wrapper";
export default function YesNoQuestion({ className, modifiers, attributes, checked, allowNil, helperText, handlePropagation, onChange, label, questionHeading, questionText, name, resource, resourceName, includeDontKnow = false, disabled = false, onAutoAdvance }) {
    const getValueOnLoad = () => {
        if (checked)
            return true;
        if (allowNil || includeDontKnow) {
            const resourceValue = resource[name];
            if (resourceValue === true)
                return true; // NOTE: an explicit `false` must stay `false`, not collapse to `null`
            // ("not answered") - otherwise a live-updating parent (any component
            // that re-renders this with new `checked`/`resource` props after a
            // state change, e.g. a fetch-driven SPA page) would visually revert
            // a "No" answer back to unselected on every other render, since this
            // is recomputed via the useEffect below whenever those props change.
            if (resourceValue === false)
                return false;
            if (resourceValue === undefined)
                return null;
            return resourceValue;
        }
        const nameValue = resource[name] || 'false';
        return nameValue === 'true';
    };
    const [value, setValue] = useState(getValueOnLoad);
    const helperIdValue = `helper-${name}`; // Update value when resource or checked changes
    useEffect(() => { setValue(getValueOnLoad()); }, [resource[name], checked]);
    const handleChange = inputValue => { const newValue = inputValue ? inputValue === 'true' : null; setValue(newValue); if (handlePropagation) {
        handlePropagation(name, newValue);
    } if (onChange) {
        onChange({ [name]: newValue });
    } if (onAutoAdvance && newValue !== null) {
        setTimeout(() => onAutoAdvance(), 200);
    } };
    const renderHeading = () => { const helper = helperText && /*#__PURE__*/ React.createElement(HelperTrigger, { helperId: helperIdValue, eventLabel: `the '${questionText}' question on a Yes-No component` }); if (questionHeading || questionText) {
        return /*#__PURE__*/ React.createElement(Question, { heading: questionHeading, text: questionText }, helper);
    }
    else if (label) {
        return /*#__PURE__*/ React.createElement(FormGroupHeader, { label: label }, helper);
    } return null; };
    const baseParams = { onChange: handleChange, name, resourceName, disabled };
    return /*#__PURE__*/ React.createElement(FormGroup, { className: className, modifiers: modifiers }, helperText && /*#__PURE__*/ React.createElement(Helper, { id: helperIdValue, body: helperText }), renderHeading(), /*#__PURE__*/ React.createElement("ul", { className: "option-group option-group--buttons" }, /*#__PURE__*/ React.createElement("li", { className: "option-group__item" }, /*#__PURE__*/ React.createElement(RadioOption, Object.assign({ value: "true", additionalAttributes: attributes && attributes.yes, label: "Yes", checked: value === true }, baseParams))), /*#__PURE__*/ React.createElement("li", { className: "option-group__item" }, /*#__PURE__*/ React.createElement(RadioOption, Object.assign({ value: "false", additionalAttributes: attributes && attributes.no, label: "No", checked: value === false }, baseParams))), includeDontKnow && /*#__PURE__*/ React.createElement("li", { className: "option-group__item" }, /*#__PURE__*/ React.createElement(RadioOption, Object.assign({ value: "", additionalAttributes: attributes && attributes.dontKnow, label: "I don't know", checked: value === null }, baseParams)))));
}
